import {formatPounds} from "../currency";

export const formatPriceRange = (
  min?: number | null,
  max?: number | null,
  denomination: "pennies" | "pounds" = "pennies",
  notation?: Intl.NumberFormatOptions["notation"],
): string => {
  if (typeof min === "number" && typeof max === "number") {
    const minLabel = formatPounds(min, denomination, false, {notation});
    const maxLabel = formatPounds(max, denomination, false, {notation});
    return `${minLabel}–${maxLabel}`;
  }
  if (typeof max === "number") {
    return `${formatPounds(max, denomination, false, {notation})} max`;
  }
  if (typeof min === "number") {
    return `${formatPounds(min, denomination, false, {notation})}+`;
  }
  return "Rent per month";
};
